import React, { useCallback, useRef } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useInteraction } from "@hooks/useInteraction";
import { ChildrenProps } from "../../types";
import { useToaster } from "../ToastMessages/useToaster";

interface CopyOnClickProps extends ChildrenProps {
    value?: string;
    tooltipText?: React.ReactNode;
    className?: string;
    stopPropagation?: boolean;
}

export const CopyOnClick: React.FC<CopyOnClickProps> = ({
    children,
    value,
    tooltipText = "Click to copy",
    className,
    stopPropagation = false,
}) => {
    const { toast } = useToaster();
    const ref = useRef<HTMLSpanElement | null>(null);
    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLSpanElement>) => {
            if (stopPropagation) {
                e.stopPropagation();
            }

            const textToCopy = value ?? ref.current?.innerText ?? "";
            navigator.clipboard.writeText(textToCopy);

            toast("Copied to clipboard");
        },
        [value, stopPropagation, toast],
    );

    const handleCopy = useInteraction(handleClick);

    return (
        <Tooltip content={tooltipText} side="bottom">
            <span ref={ref} {...handleCopy} className={className}>
                {children}
            </span>
        </Tooltip>
    );
};
